import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card';
import { ReactNode } from 'react';

interface TooltipProps {
  trigger: ReactNode;
  children: ReactNode;
}

export const Tooltip = ({ trigger, children }: TooltipProps) => {
  return (
    <HoverCard openDelay={0}>
      <HoverCardTrigger>{trigger}</HoverCardTrigger>
      <HoverCardContent>{children}</HoverCardContent>
    </HoverCard>
  );
};
